// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cfe366{cursor:pointer;margin-left:var(--flex-gutter) !important}.cfe366[data-status=uploading]{pointer-events:none}.cfe366[data-status=uploading] ._37cb70{display:none}.cfe366:not([data-status=uploading]) .a18ee7{display:none}", ""]);
// Exports
exports.locals = {
	"container": "cfe366",
	"icon": "_37cb70",
	"spinner": "a18ee7"
};
module.exports = exports;
